import { Actions, AppContext, Events, UnityBridge } from "@Context/common/general/context";
import { useCallback, useContext } from "react";
import { useNavigate } from "react-router-dom";

export const useNotificationActions = () => {
  const { dispatch, state } = useContext(AppContext);
  const navigate = useNavigate();

  const handleLogout = useCallback(() => {
    dispatch({ type: Actions.FirebaseActions.Logout });
  }, [dispatch]);

  const handleExit = useCallback(() => {
    UnityBridge.dispatchWebEvent({
      type: UnityBridge.OutgoingWebEvents.ExitApplicationSignal,
    });
  }, []);

  const handleSelectAccount = useCallback(() => {
    Events.account.resetAccountState.emit();
    navigate("/select-account", { replace: true });
  }, [navigate]);

  const handleSelectPlan = useCallback(() => {
    if (state.device.isUnityEmbedded) {
      UnityBridge.dispatchWebEvent({
        type: UnityBridge.OutgoingWebEvents.OpenExternalUrl,
        payload: {
          url: "https://portal.beyourbest.com/",
        },
      });

      return;
    }

    navigate("/product-selection");
  }, [navigate, state.device.isUnityEmbedded]);

  return {
    handleExit,
    handleLogout,
    handleSelectAccount,
    handleSelectPlan,
  };
};
